<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('ui.contactPerson') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <div class="form-group">
          <label>
            {{ $t('ui.nameAndSurename') }}:
          </label><br>

          <strong>{{ name }}</strong>
        </div>

        <div class="form-group">
          <label>
            {{ $t('ui.emailAddress') }}:
          </label><br>

          <strong>{{ email }}</strong>
        </div>

        <div class="form-group">
          <label>
            {{ $t('customer.telephone') }}:
          </label><br>

          <strong>{{ phone }}</strong>
        </div>

        <div class="form-group">
          <label>
            {{ $t('customer.newsletterAgreement') }}:
          </label><br>
          <span
            :class="{
              'd-block': true,
              'text-success': newsletter_status === 'SUBSCRIBED',
              'text-danger': newsletter_status === 'UNSUBSCRIBED'
            }">
            <template v-if="newsletter_status === 'SUBSCRIBED'">
              {{ $t('customer.newsletterStatus.subscribed') }}
            </template>
            <template v-if="newsletter_status === 'UNSUBSCRIBED'">
              {{ $t('customer.newsletterStatus.unsubscribed') }}
            </template>
            <template v-if="newsletter_status === null">
              {{ $t('customer.newsletterStatus.null') }}
            </template>
          </span>

          <br>
          <label>
            {{ $t('customer.newsletterStatusAt') }}:
          </label>
          <div>
            <template v-if="newsletter_status_at">
              {{ newsletter_status_at }}
            </template>
            <template v-else>
              &mdash;
            </template>
          </div>
        </div>
      </d-form>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'customer-contact-person-view-popup',
  props: {
    personData: {
      default: () => ({}),
      type: Object
    }
  },
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      newsletter_status: null
    };
  },
  mounted () {
    this.name = this.personData.name;
    this.phone = this.personData.phone;
    this.email = this.personData.email;
    this.newsletter_status = this.personData.newsletter_status;
    this.newsletter_status_at = this.personData.newsletter_status_at;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('customer-view-contact-person-popup-close');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
